import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TonalButtonLarge = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Tonal Large button"}
        value={"<Button variant={\"tonal\"} size={'large'}>Large</Button>"}
      >
        <Button variant={"tonal"} size={"large"}>
          Large
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default TonalButtonLarge;
